import { Avatar } from '@components/atoms/Avatar';
import { useCurrentUser } from '@hooks/api';

export const UserButton = ({ goToSettings }: { goToSettings: () => void }) => {
  const { data: user } = useCurrentUser();

  const hasName = user?.getSelf?.firstName || user?.getSelf?.lastName;
  const displayName = hasName
    ? `${user?.getSelf?.firstName || ''} ${user?.getSelf?.lastName || ''}`.trim()
    : user?.getSelf?.email || '';

  return (
    <div
      onClick={goToSettings}
      data-testid="sidebar-user-button"
      className="flex gap-2 items-center hover:bg-white/5 transition-colors duration-200 cursor-pointer p-2 rounded-lg">
      <Avatar
        size="sm"
        src={user?.getSelf?.avatar || ''}
        text={displayName.charAt(0) || ''}
      />

      <div className="flex flex-col">
        <span className="text-white text-xs truncate w-40">{displayName}</span>
        <span className="text-white/70 dark:text-gray-300 text-xs truncate w-40">
          {user?.getSelf?.role}
        </span>
      </div>
    </div>
  );
};
